var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-arrow-right",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-arrow-right1",
    serifid: "iconB-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.657,13l-11.728,-0c-0.552,-0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1l11.728,0l-5.364,-5.364c-0.39,-0.39 -0.39,-1.024 -0,-1.414c0.39,-0.391 1.024,-0.391 1.414,-0l7.071,7.071c0.191,0.19 0.293,0.444 0.293,0.707c0,0.263 -0.102,0.517 -0.293,0.707l-7.071,7.071c-0.39,0.39 -1.024,0.39 -1.414,0c-0.39,-0.39 -0.39,-1.024 -0,-1.414l5.364,-5.364Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBArrowRight);
export default __webpack_public_path__ + "static/media/iconB-arrow-right.e2a715ff497f442cc98b94a77d6c95f9.svg";
export { ForwardRef as ReactComponent };